import { ShopDineRelaxCategory } from '../../../domain/models/ShopDineRelaxCategory';

export enum PoiListScope {
	All = 'all',
	Shop = 'shop',
	Dine = 'dine',
	Relax = 'relax',
}

export const scopeLabels = [
	{ scope: PoiListScope.All, label: 'All' },
	{ scope: PoiListScope.Shop, label: 'Shop' },
	{ scope: PoiListScope.Dine, label: 'Dine' },
	{ scope: PoiListScope.Relax, label: 'Relax' },
];

// Map from PoiListScope to ShopDineRelaxCategory
export const scopeToCategoryMap: Record<PoiListScope, string> = {
	[PoiListScope.All]: PoiListScope.All,
	[PoiListScope.Shop]: ShopDineRelaxCategory.Shop,
	[PoiListScope.Dine]: ShopDineRelaxCategory.Eat,
	[PoiListScope.Relax]: ShopDineRelaxCategory.Relax,
};
